import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import CalendarPage from './pages/CalendarPage';
import TasksStatsPage from './pages/TasksStatsPage';
import TasksPage from './pages/TasksPage';
import UsersPageV2 from './pages/UsersPageV2';
import APITokensPage from './pages/APITokensPage';
import SubmissionsPage from './pages/SubmissionsPage';
import QueueStatsPage from './pages/QueueStatsPage';
import LogsPage from './pages/LogsPage';
import ClientsPage from './pages/ClientsPage';
import HoursPage from './pages/HoursPage';
import NotFoundPage from './pages/NotFoundPage';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const App: React.FC = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* Requires a secret token in the URL (see ADMIN_ACCESS_TOKEN) —
                AdminLoginPage itself verifies the token with the backend and
                renders NotFoundPage if it's missing or wrong. */}
            <Route path="/login/admin/:token" element={<AdminLoginPage />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <TasksStatsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <PrivateRoute>
                  <CalendarPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/tasks"
              element={
                <PrivateRoute>
                  <TasksPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <UsersPageV2 />
                </PrivateRoute>
              }
            />
            <Route
              path="/clients"
              element={
                <PrivateRoute>
                  <ClientsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/api-tokens"
              element={
                <PrivateRoute>
                  <APITokensPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/submissions"
              element={
                <PrivateRoute>
                  <SubmissionsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/queue-stats"
              element={
                <PrivateRoute>
                  <QueueStatsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/logs"
              element={
                <PrivateRoute>
                  <LogsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/hours"
              element={
                <PrivateRoute>
                  <HoursPage />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/calendar" replace />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AuthProvider>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;

